"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
function CreatorReviewsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="rounded-xl bg-muted/30 animate-pulse h-80" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">Unable to load posts at this time.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">No posts available yet.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => {
      return <Link key={post.id} data-index={i} to={post.link || "#"} className="group block rounded-xl overflow-hidden bg-background shadow-soft hover-lift transition-all">
            {post.featuredImage && <div className="aspect-video w-full overflow-hidden bg-muted">
                <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover transition-transform group-hover:scale-105" style={{
            transitionDuration: "var(--duration-medium)",
            transitionTimingFunction: "var(--ease-out-back)"
          }} />
              </div>}
            
            <div className="p-6">
              <h3 className="text-xl font-semibold text-foreground mb-3 group-hover:text-primary transition-colors">
                {post.title}
              </h3>

              {post.excerpt && <div className="text-sm text-muted-foreground line-clamp-3 mb-4" dangerouslySetInnerHTML={{
            __html: post.excerpt
          }} />}

              <span className="text-sm font-bold text-primary inline-flex items-center gap-1 group-hover:translate-x-1 transition-transform">
                Read More
              </span>
            </div>
          </Link>;
    })}
    </div>;
}
export default function CreatorReviewsSection() {
  return <section id="creatorreviews" className="py-16 px-4 bg-background !bg-[url(https://screenado.com/wp-content/uploads/2026/02/Screenado-Collage-Banner-4.jpg)]">
      <div className="max-w-7xl mx-auto ![padding:20px_0px_10px_0px]">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-display font-bold text-foreground mb-4">
            Latest Creator Reviews
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover what parents think about popular YouTube creators for kids
          </p>
        </div>

        <PostsProvider postType="post" wp_query={{
        per_page: 3,
        status: ["publish"],
        order: "desc",
        orderby: "date"
      }}>
          <CreatorReviewsConsumer />
        </PostsProvider>
      </div>
    </section>;
}